import React from 'react';
import { Link } from 'react-router-dom';
import './InteractiveLabs.css'; // Importing the CSS file
import useSound from '../Sound';

function InteractiveLabs() {
    const playClickSound = useSound('/ui-click-43196.mp3'); // Local file path

    const handleSound = () => {
        playClickSound();
    };

    return (
        <div className="lab-container">
            <h1 className="lab-title">Interactive Labs</h1>
            <div className="lab-sections">
                <div className="lab-section">
                    <h2>Biochemistry/Biology Labs</h2>
                    <ul className="lab-list">
                        <li className="lab-link">
                            <a onClick={handleSound} href="/MoleculeViewer">Macromolecule Visualizer</a>
                        </li>
                    </ul>
                </div>
                <div className="lab-section">
                    <h2>Organic/General Chemistry Labs</h2>
                    <ul className="lab-list">
                        <li className="lab-link"><a onClick={handleSound} href="/chemstuff">Molecular Editor</a></li>
                        <li className="lab-link"><a onClick={handleSound} href="/atom">Periodic Table Bohr Model</a></li>
                    </ul>
                </div>
                <div className="lab-section">
                    <h2>Physics Lab</h2>
                    <ul className="lab-list">
                        <li className="lab-link"><a onClick={handleSound} href="/Physicslab1">Free Falling Ball</a></li>
                        <li className="lab-link"><a onClick={handleSound} href="/Physicslab2">Momentum</a></li>
                        <li className="lab-link"><a onClick={handleSound} href="/Physicslab3">Wave Sketch</a></li>
                        <li className="lab-link"><a onClick={handleSound} href="/Physicslab5">Wave Interference</a></li>
                    </ul>
                </div>
                <div className="lab-section">
                    <h2>Algebra Labs</h2>
                    <ul className="lab-list">
                        <li className="lab-link"><a onClick={handleSound} href="/Algebralab2">Set Operations</a></li>
                        <li className="lab-link"><a onClick={handleSound} href="/Algebralab3">Function Graph</a></li>
                        <li className="lab-link"><a onClick={handleSound} href="/Algebralab4">Solve Equation</a></li>
                    </ul>
                </div>
            </div>
        </div>
    );
}

export default InteractiveLabs;
